var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-shipment-address-not-found-dialog-map"},[_c('div',{ref:"container",staticClass:"new-shipment-address-not-found-dialog-map__map"})])}
var staticRenderFns = []

export { render, staticRenderFns }